module.exports = __webpack_public_path__ + "static/media/rectangle-dropdown.5de2b18c.svg";